var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarLineNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.28 -526.41)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.78,526.41c2.05,0,3.92.59,5.26,1.54,1.38.98,2.24,2.35,2.24,3.85s-.86,2.88-2.24,3.85c-1.35.97-3.21,1.55-5.26,1.55-.35,0-.71-.02-1.07-.07-.31-.02-.62-.07-.91-.12l-3.56,2.05c-.09.03-.19.05-.28.03-.19-.05-.31-.26-.26-.45l.85-2.99c-.66-.47-1.21-1.02-1.61-1.64-.41-.69-.66-1.43-.66-2.23,0-1.5.86-2.87,2.24-3.85,1.35-.95,3.21-1.54,5.25-1.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 29.68,
    cy: 531.79,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 32.78,
    cy: 531.79,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 35.89,
    cy: 531.79,
    r: 0.97
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLineNotification);
export default __webpack_public_path__ + "static/media/sidebar_line_notification.897eef5220e9cb8dd14b6fae8236320a.svg";
export { ForwardRef as ReactComponent };